// @flow
import React, { Component } from 'react';
import { Dropdown } from 'semantic-grab-ui/src';
import _ from 'lodash';

type Props = {
  placeholder: string,
  values: Array,
  onChange: Function,
};

// MultiItemTextbox is a textbox where user can type in a list of items
export default class MultiItemTextbox extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      values: [],
      options: [],
    };
  }

  componentDidMount = () => {
    const values = _.get(this.props, 'values', []);
    if (_.isArray(values)) {
      // set the values as dropdown options so that they can display
      const options = values.map(value => {
        return {
          key: value,
          value,
          text: value,
        };
      });

      this.setState({
        values,
        options,
      });
    }
  };

  onAddItem = (event: any, data: any) => {
    this.setState((prevState) => ({
      options: [{ text: data.value, value: data.value, key: data.value }, ...prevState.options],
    }));
  };

  onValueChange = (event: any, data: any) => {
    this.setState({
      values: data.value,
    });
    this.props.onChange(event, data);
  };

  render() {
    return (
      <Dropdown
        placeholder={_.get(this.props, 'placeholder', '')}
        search
        selection
        allowAdditions
        multiple
        value={_.get(this.state, 'values', [])}
        options={_.get(this.state, 'options', [])}
        onAddItem={this.onAddItem}
        onChange={this.onValueChange}
      />
    );
  }
}
